import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ILoginRes, IPerfilamiento } from 'src/app/interfaces/usuarios';
import { PerfilamientoService } from 'src/app/services/perfilamiento/perfilamiento.service';
import { UsuariosService } from 'src/app/services/usuarios/usuarios.service';

@Component({
  selector: 'app-callback',
  templateUrl: './callback.component.html',
  styleUrls: ['./callback.component.scss']
})
export class CallbackComponent {
  code: string = ''
  session: string = ''
  error: string = ''
  tokenDecode: any

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private spinner: NgxSpinnerService,
    private _usuarios: UsuariosService,
    private _perfilamiento: PerfilamientoService
  ) {

  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.code = params['code']
      this.session = params['session_state']
    })
    this._usuarios.login({accessToken: this.code}).subscribe(
      (res: ILoginRes) => {
        if ( res.error === null ) {
          this._usuarios.setToken(res.token)
          this._perfilamiento.getPerfilamiento().subscribe(
            (res: IPerfilamiento) => {
              if ( res.usuario ) {
                this._perfilamiento.setUsuario(res.usuario)
              }
              if ( res.menuUsuario ) {
                this._perfilamiento.setMenu(res.menuUsuario)
              }
              if (res.usuario.tipoUsuario == 'Docente') {
                this.router.navigate(['/portal-calificacion']);
              } else {
                this.router.navigate(['/view-inicio'])
              }
            }
          )
        } else {
          this.router.navigate(['/sin-acceso'])
        }
      }, (err: any) => {
        this.router.navigate(['/sin-acceso'])
      }
    )
  }
}
